export var LobbyAction = /*#__PURE__*/ function(LobbyAction) {
    LobbyAction[LobbyAction["ClickedBotGame"] = 2] = "ClickedBotGame";
    LobbyAction[LobbyAction["ClickedCreateRoom"] = 3] = "ClickedCreateRoom";
    LobbyAction[LobbyAction["ClickedJoinRoom"] = 4] = "ClickedJoinRoom";
    LobbyAction[LobbyAction["AccessGameLink"] = 5] = "AccessGameLink";
    LobbyAction[LobbyAction["ClickedSpectateGame"] = 6] = "ClickedSpectateGame";
    LobbyAction[LobbyAction["ReconnectGame"] = 7] = "ReconnectGame";
    LobbyAction[LobbyAction["SaveClientReferrer"] = 8] = "SaveClientReferrer";
    LobbyAction[LobbyAction["SetAdBlockStatus"] = 9] = "SetAdBlockStatus";
    LobbyAction[LobbyAction["InteractedWithSite"] = 10] = "InteractedWithSite";
    LobbyAction[LobbyAction["ClickedStartBeginnerMode"] = 11] = "ClickedStartBeginnerMode";
    LobbyAction[LobbyAction["Clicked1v1BeginnerBotGame"] = 12] = "Clicked1v1BeginnerBotGame";
    LobbyAction[LobbyAction["ClickedEasyBotGame"] = 13] = "ClickedEasyBotGame";
    LobbyAction[LobbyAction["WatchRoomList"] = 14] = "WatchRoomList";
    LobbyAction[LobbyAction["StopWatchingRoomList"] = 15] = "StopWatchingRoomList";
    LobbyAction[LobbyAction["AutoRejoinGame"] = 16] = "AutoRejoinGame";
    LobbyAction[LobbyAction["ClickedRushBotGame"] = 18] = "ClickedRushBotGame";
    return LobbyAction;
}({});
export const PRIMARY_LOBBY_ACTIONS = [
    11,
    2,
    12,
    3,
    4,
    5,
    6,
    7,
    18
];
